export default __webpack_public_path__ + "static/AntiqueOliveStd-Nord-8e53d47ee98ee747efd0151b9d25adfa.woff2";